import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import { t } from '../../i18n'
import styles from './header.module.scss'


export default function Doofinder({}) {
  const store_id = process.env.GATSBY_DOOFINDER_STORE_ID;
  const store_url = `https://eu1-config.doofinder.com/2.x/${store_id}.js`;

  return (
    <React.Fragment>
        <Helmet>
            <script src={store_url} async></script>
        </Helmet>
        <div className={styles.doofinder_search} data-doofinder={store_id} >
          <input id="doofinder-search-box" type="search" className="doofinder-search-box"  placeholder={t('doofinder.search_placeholder')} />
        </div>
    </React.Fragment>
    )
}

